"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./resident-dto");
require("./ilu-unit-dto");
class ViewEnquiryDto {
}
exports.ViewEnquiryDto = ViewEnquiryDto;
